import React, { memo, MouseEvent } from 'react';
import { isEmpty } from 'lodash';
import { Chip, Link, LinkProps, Stack, SxProps, Typography } from '@mui/material';
import Icon from 'components/atoms/Icon';
import { theme } from 'theme';

export type PostProps = {
    icon: string;
    header?: string;
    subHeader?: string;
    to?: string;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    isDisabled?: boolean;
    sx?: SxProps<typeof theme>;
} & LinkProps;


export const Post = memo(function ({isDisabled, to, onClick, icon, header, subHeader, sx, ...restProps}: PostProps): JSX.Element {
    const baseSx: SxProps<typeof theme>  = {
        border: '1px solid #0f99a8',
        textDecoration: 'none',
        fill: '#0376a8',
        color: '#0376a8',
        display: 'flex',
        padding: '20px',
        flexDirection: 'column',
        borderRadius: '0.3rem',
        justifyContent: 'space-between',
        boxShadow: '4px 4px 4px #4c4c4f33',
        transition: 'background-color 0.3s ease',
        '&:hover': {
            border: '1px solid #0f99a8',
            backgroundColor: '#0f99a8',
            fill: 'white',
            color: 'white',
            textDecoration: 'none',
        },
    };
    const disabledSx: SxProps<typeof theme>  = {
        pointerEvents: isDisabled ? 'none' : 'auto',
        filter: isDisabled ? 'grayscale(100%)' : 'none',
        opacity: isDisabled ? 0.5 : 1,
        transition: 'all 0.3s ease',
    };
    return (
        <Link href={isDisabled ? undefined : to} onClick={isDisabled ? undefined : onClick} sx={{...baseSx, ...(isDisabled && disabledSx), ...sx}} {...restProps}>
            <Stack direction="column" gap={2} alignItems="center">
                {isDisabled && (<Chip color="info" style={{color: 'white', alignSelf:'baseline', position:'absolute', top: '10px'}} label="Pending"/>)}
                
                <Icon icon={icon} size="5x" className="text-center" aria-label={icon} />
                {!isEmpty(header) && (
                    <Typography variant="subtitle1" fontWeight="bold">{header}</Typography>
                )}
                {!isEmpty(subHeader) && <Typography>{subHeader}</Typography>}
            </Stack>
        </Link>
    );
});

export default Post;
